import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { designTokens } from '../../styles/designTokens';
import Button from '../Button';
import PhoneNumberInput, { phoneUtils } from '../PhoneNumberInput';

const useStyles = makeStyles((theme) => ({
    phoneContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    label: {
        ...designTokens.typography.body,
        display: 'block',
        marginBottom: '-8px',
    },
}));

const PhoneInputStep = ({ onSubmit, loading, notFound, phoneNumber, onCreateNew }) => {
    const classes = useStyles();
    const [phone, setPhone] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            setTimeout(() => {
                inputRef.current.focus();
            }, 100);
        }
    }, []);

    const handleSubmit = () => {
        if (phoneUtils.isValidPhone(phone)) {
            const fullPhone = phoneUtils.getFullPhone(phone);
            onSubmit(fullPhone);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <div className={classes.phoneContainer}>
            <label className={classes.label}>Номер телефону</label>

            <PhoneNumberInput
                value={phone}
                onChange={setPhone}
                onKeyPress={handleKeyPress}
                autoFocus
                inputRef={inputRef}
                placeholder="(XX) XXX - XX - XX"
            />

            {notFound && (
                <Button
                    variant="outlined"
                    onClick={onCreateNew}
                    icon={<AddIcon />}
                    iconPosition="left"
                    size="small"
                >
                    Додати нового пацієнта
                </Button>
            )}

            <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={!phoneUtils.isValidPhone(phone) || loading}
                loading={loading}
                fullWidth
            >
                Отримати дані пацієнта
            </Button>
        </div>
    );
};

export default PhoneInputStep;
